/* global axios */

import CacheEnabledApiClient from './CacheEnabledApiClient';

class CannedResponse extends CacheEnabledApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'canned_response';
  }

  // The index endpoint returns a bare array instead of a payload wrapper
  // eslint-disable-next-line class-methods-use-this
  extractDataFromResponse(response) {
    return response.data;
  }

  // eslint-disable-next-line class-methods-use-this
  marshallData(dataToParse) {
    return { data: dataToParse };
  }

  createWithAttachments({ short_code, content, files = [] }) {
    const formData = new FormData();
    formData.append('canned_response[short_code]', short_code);
    formData.append('canned_response[content]', content);
    files.forEach(file => {
      formData.append('canned_response[files][]', file);
    });
    return axios.post(this.url, formData);
  }

  updateWithAttachments(
    id,
    { short_code, content, files = [], removedAttachmentIds = [] }
  ) {
    const formData = new FormData();
    formData.append('canned_response[short_code]', short_code);
    formData.append('canned_response[content]', content);
    files.forEach(file => {
      formData.append('canned_response[files][]', file);
    });
    removedAttachmentIds.forEach(blobId => {
      formData.append('canned_response[removed_attachment_ids][]', blobId);
    });
    return axios.put(`${this.url}/${id}`, formData);
  }
}

export default new CannedResponse();
